import { GET_MORE_DOCUMENTS, GET_ALL_DOCUMENTS, UPDATE_LIST_DOCUMENT } from '../actions';

export const documents = (state = { documents: [] }, action) => {
  switch (action.type) {
    case UPDATE_LIST_DOCUMENT:
      return { ...state, documents: action.payload };
    case GET_MORE_DOCUMENTS:
      return { ...state, documents: [...state.documents, ...action.payload.items], nextToken: action.payload.nextToken };
    case GET_ALL_DOCUMENTS:
      return { ...state, documents: action.payload.items, nextToken: action.payload.nextToken };
    case 'CLEAN_STATE':
      return {};
    default:
      return state;
  }
};
